import { defineStore } from 'pinia'

export const useAccessStore = defineStore('access', {
  state: () => ({
    permissions: [] as string[],
  }),
  actions: {
    setPermissions(list: string[]) {
      this.permissions = list
    },
    has(name: string) {
      return this.permissions.includes(name)
    },
    hasAny(names: string[]) {
      return names.some((name) => this.has(name))
    },
  },
})
